import { Component, OnInit, Input } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ActivatedRoute, Data } from '@angular/router';

import { Lead } from '../../../../shared/lead';
import { BrandService } from '../../../../services/brand.service';
import { FruHttpService } from '../../../../services/fru-http.service';
import { SelectedLendersService } from '../../../../services/selected-lenders.service';
import { environment } from '../../environments/environment';
import { OfficeStatus } from '../../../../shared/office-status';
import { SelectedResponse, SelectedList } from '../../../../shared/selected-response.model';

@Component({
  selector: 'one-to-one-consent',
  templateUrl: './one-to-one-consent.component.html',
  styleUrls: ['./one-to-one-consent.component.scss']
})
export class OneToOneConsentComponent implements OnInit {
  @Input() lead: Lead;
  public officeStatus: OfficeStatus;
  public msg: string;
  public currentYear: number = 2023;
  public encryptedLeadId: string;
  public selectedEnabled: boolean = false;

  availableSelected$: Observable<SelectedResponse>;

  constructor(private fruHttp: FruHttpService,
    private selectedLendersService: SelectedLendersService,
    private route: ActivatedRoute,
    public brandService: BrandService)
  {
    this.availableSelected$ = selectedLendersService.selectedLenders$;
  }

  ngOnInit() {
    let d = new Date();
    this.currentYear = d.getFullYear();

    this.route.queryParams.subscribe(params => {
      this.msg = (params.utm_medium == 'click-expired')
        ? 'please verify your information to get updated rates.'
        : 'as we discussed in my message, please verify the information below is still accurate. Thank you!';

      this.fruHttp
        .getOfficeStatus(params.utm_source || 'consumer_campaign')
        .subscribe(officeStatus => this.officeStatus = officeStatus)
    });


    this.getLead();


    this.route.queryParams.subscribe(params =>
      this.fruHttp
        .getOfficeStatus(params.utm_source || 'consumer_campaign')
        .subscribe(officeStatus => this.officeStatus = officeStatus)
    );

    this.encryptedLeadId = this.route.snapshot.paramMap.get('id');
    if (this.selectedEnabled) {
      this.selectedLendersService.getList(this.encryptedLeadId, 0, 'consent-form');
    }
  }

  getLead() {
    const id = this.route.snapshot.paramMap.get('id');
    const leadType: string = this.route.snapshot.data.type || '';

    if (!id) {
      this.redirectToMainForm();
    }

    this.fruHttp.getLead(id, leadType).subscribe(lead => {
      this.lead = lead;

      if (this.lead === null) {
        this.redirectToMainForm();
      } else {
        let params: any = this.route.snapshot.queryParams;
        if (params.utm_source) {
          this.lead.adnetwork = params.utm_source;
        }
        this.lead.medium = params.utm_medium || '';
        this.lead.campaign = id; // Store the encrypted id
        this.lead.keyword = params.utm_keyword || '';
        this.lead.content = params.utm_content || '';
        this.lead.network = params.network || '';
		    this.lead.gclid = params.gclid || '';
        this.lead.clickid = params.msclkid || '';
      }
    });
  }

  redirectToMainForm() {
    if (environment.production) {
      this.fruHttp.redirectMainForm();
    } else {
      document.write("Invalid URL. Normally I'd redirect to the normal form, but this is a development site.");
    }
  }
}
